<template>
  <v-container
    fluid
    class="grey lighten-3 fixed-element"
    :class="[!btBlock ? 'btn-center' : '']"
  >
    <v-btn
      color="primary"
      outlined
      :block="btBlock"
      :max-width="maxWidthBt"
      :width="widthBt"
      data-cy="btn_voltar"
      @click="linkVoltar"
    >
      Voltar
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'BtnVoltar',

  props: {
    voltarPara: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: '',
    },
  },

  computed: {
    widthBt() {
      return this.maxWidth !== '' ? '100%' : '';
    },

    maxWidthBt() {
      return this.maxWidth !== '' ? this.maxWidth : 'auto';
    },

    btBlock() {
      return this.maxWidth === '';
    },
  },

  methods: {
    linkVoltar() {
      if (this.voltarPara === '') return this.$router.go(-1);

      return this.$router.push(this.voltarPara);
    },
  },
};
</script>

<style lang="scss">
  .fixed-element {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
  }
  .btn-center {
    text-align: center;
  }
</style>
